__turbopack_context__.v({
  "container": "Container-module__WxQwYW__container",
});
